export function nossFilter() {
    let filters = document.querySelectorAll('.filters');
    if (filters) {
        for (let i = 0; i < filters.length; ++i) {
            let code = filters[i].dataset.filtercode;
            if (code === undefined) {
                code = '';
            }
            let activeInnerFilter = filters[i].querySelector('li.active');
            if (!activeInnerFilter) {
                filters[i].querySelector('li').classList.add('active');
            }

            let innerFilters = filters[i].querySelectorAll('li');
            if (innerFilters) {
                for (let j = 0; j < innerFilters.length; ++j) {
                    innerFilters[j].addEventListener('click', (event) => {
                        if (!event.target.classList.contains('active')) {
                            event.target.parentNode.querySelector('li.active').classList.remove('active');
                            event.target.classList.add('active');

                            let filterClass = event.target.dataset.filter;

                            if (event.target.closest('.noss-filter')) {
                                if (filterClass == '') {
                                    // reset
                                    let items = event.target.closest('.noss-filter').querySelector('.items').querySelectorAll('.item.filtered' + code);
                                    for (let k = 0; k < items.length; ++k) {
                                        items[k].classList.remove('filtered' + code);
                                    }
                                } else {
                                    // filter
                                    let items = event.target.closest('.noss-filter').querySelector('.items').querySelectorAll('.item');
                                    if (items) {
                                        for (let k = 0; k < items.length; ++k) {
                                            if (items[k].classList.contains(filterClass)) {
                                                items[k].classList.remove('filtered' + code);
                                            } else {
                                                items[k].classList.add('filtered' + code);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
            }
        }
    }
}